var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRotatePhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 78 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#rotatePhone_svg__clip0_1983_4715)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.36 71.417a36.005 36.005 0 01-7.795-5.93C7.993 58.912 4.247 50.248 4.569 42.308L.02 42.132C-.333 51.326 3.91 61.259 11.354 68.7 17.976 75.323 26.398 79.34 35.672 80L24.34 68.667l-1.979 2.75zM55.46 8.583a35.99 35.99 0 017.796 5.93c6.574 6.575 10.32 15.238 9.998 23.178l4.548.177c.354-9.194-3.89-19.127-11.333-26.569C59.849 4.677 51.427.66 42.153 0l11.333 11.333 1.975-2.75z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 4,
    d: "M3.52 29.683L29.683 3.52l45.27 45.27L48.79 74.955z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "rotatePhone_svg__clip0_1983_4715"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h77.823v80H0z"
  })))));
}

export default SvgRotatePhone;